export default "__VITE_ASSET__0a1a9fcf__"